import { useTranslation } from "react-i18next";

// Stable values (do not translate these)
export const TIPO_INPUT = {
    TEXTO: "texto",
    NUMERO: "numero",
    FECHA: "fecha",
    HORA: "hora",
    NOTA: "nota",
    GEOCERCA_ORIGEN: "geocerca_origen",
    GEOCERCA_DESTINO: "geocerca_destino",
    GEORUTA: "georuta",
    FECHA_SALIDA: "fecha_salida",
    FECHA_LLEGADA: "fecha_llegada",
    HORA_SALIDA: "hora_salida",
    HORA_LLEGADA: "hora_llegada",
    SELECCIONE_VEHICULO: "seleccione_vehiculo",
};

// Use this hook inside React components to get translated labels
export const useTipoInputOptions = () => {
    const { t } = useTranslation();

    return [
        { value: TIPO_INPUT.TEXTO, label: t("label_texto") },
        { value: TIPO_INPUT.NUMERO, label: t("label_numero") },
        { value: TIPO_INPUT.FECHA, label: t("label_fecha") },
        { value: TIPO_INPUT.HORA, label: t("label_hora") },
        { value: TIPO_INPUT.NOTA, label: t("label_nota") },
        { value: TIPO_INPUT.GEOCERCA_ORIGEN, label: t("label_geocerca_origen") },
        { value: TIPO_INPUT.GEOCERCA_DESTINO, label: t("label_geocerca_destino") },
        { value: TIPO_INPUT.GEORUTA, label: t("label_georuta") },
        { value: TIPO_INPUT.FECHA_SALIDA, label: t("label_fecha_salida") },
        { value: TIPO_INPUT.FECHA_LLEGADA, label: t("label_fecha_llegada") },
        { value: TIPO_INPUT.HORA_SALIDA, label: t("label_hora_salida") },
        { value: TIPO_INPUT.HORA_LLEGADA, label: t("label_hora_llegada") },
        { value: TIPO_INPUT.SELECCIONE_VEHICULO, label: t("label_seleccione_vehiculo") },
    ];
};
